import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { BREAKPOINTS, isMobileView } from '../utilities/index';

(function () {
  'use strict';

  function addBlankSlides({ swiper, extendParams, on }) {
    let add_elms = [];

    const createElement = (tag, classes) => {
      if (classes === void 0) {
        classes = [];
      }
      const el = document.createElement(tag);
      el.classList.add(...(Array.isArray(classes) ? classes : classesToTokens(classes)));
      return el;
    };

    const add = (amountOfSlides) => {
      for (let i = 0; i < amountOfSlides; i += 1) {
        const slideEl = swiper.isElement ? createElement('swiper-slide', [swiper.params.slideBlankClass]) : createElement('div', [swiper.params.slideClass, swiper.params.slideBlankClass]);
        swiper.slidesEl.append(slideEl);
        add_elms.push(slideEl);
      }
    };

    const check = () => {
      const slidesPerGroup = swiper.params.slidesPerGroup;
      const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
      if (slidesPerGroup != slidesToAdd) {
        add(slidesToAdd);
      }
    };


    on('init', () => {
      check();
    });
    on('breakpoint', () => {
      add_elms.forEach(elm => {
        elm.remove();
      });
      add_elms = [];
      swiper.update(true);
      check();
    });
  }

  class SliderList {
    constructor(wrap) {
      this.wrap = wrap;
      this.el_sw = this.wrap.querySelector('.swiper');
      this.el_sw_wrap = this.wrap.querySelector('.swiper-wrapper');
      this.swiper = null;
    }

    resize(v) {
      //console.log('resize');
      // clear
      this.removeSlide();
      this.el_sw_wrap.querySelectorAll('.swiper-slide').forEach((s) => {
        s.querySelectorAll('.c-sliderList__slide').forEach((ds) => {
          this.el_sw_wrap.appendChild(ds);
        });
        s.remove();
      });

      // .swiper-slideに分ける
      const n = v==='pc'?1:3;
      let elm, append;
      this.el_sw_wrap.querySelectorAll('.c-sliderList__slide').forEach((ds, i) => {
        if (i % n === 0) {
          append = false;
          elm = document.createElement('div');
          elm.classList.add('swiper-slide');
        }
        elm.appendChild(ds);
        if (i % n === n - 1) {
          append = true;
          this.el_sw_wrap.appendChild(elm);
        }
      });
      if (!append) {
        this.el_sw_wrap.appendChild(elm);
      }

      // swiper
      this.setSlide();
    }

    removeSlide() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
      }
    }
    setSlide() {
      const next = this.wrap.querySelector('.swiper-button-next');
      const prev = this.wrap.querySelector('.swiper-button-prev');
      const page = this.wrap.querySelector('.swiper-pagination');

      // data
      const wideSlidesPerView = this.wrap.dataset.wideSlidesPerView?Number(this.wrap.dataset.wideSlidesPerView):3;

      this.swiper = new Swiper(this.el_sw, {
        modules: [Navigation, Pagination, addBlankSlides],
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 25,
        breakpoints: {
          [BREAKPOINTS.desktop]: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 24,
          },
          [BREAKPOINTS.wide]: {
            slidesPerView: wideSlidesPerView,
            slidesPerGroup: wideSlidesPerView,
            spaceBetween: 24,
          }
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        pagination: {
          el: page,
          type: "fraction",
        },
      });
    }
  }

  // init //--------//
  const wraps = [];
  document.querySelectorAll('.c-sliderList').forEach((wrap) => {
    wraps.push(new SliderList(wrap));
  });
  
  // window resize //--------//
  let current_mode = isMobileView() ? 'sp' : 'pc';
  let resize_timer = false;
  function resizeFunc() {
    //console.log('resizeFunc');
    for (let i = 0; i < wraps.length; i++) {
      wraps[i].resize(current_mode);
    }
  }

  if (wraps.length > 0) {
    window.addEventListener('resize', () => {
      if (resize_timer !== false) {
          clearTimeout(resize_timer);
      }
      resize_timer = setTimeout(function() {
        const new_mode = isMobileView() ? 'sp' : 'pc';
        if (new_mode !== current_mode) {
          current_mode = new_mode;
          resizeFunc();
        }
        
      }, 200);
    });
    resizeFunc();
  }


})();